import { GetterTree } from 'vuex'
import { StoreInterface } from 'src/store'
import { SessionStoreInterface } from 'src/store/session/state'
import {
  ContentSetting,
  DisplaySetting,
  DisplaySettingValue,
  AssetTypeEnum,
  ItemSetting,
  UserId,
  SessionSettingEnum,
  UserSettingEnum, RoleName, RoleIdNameEnum, ItemTypeEnum
} from 'able-lib'
import { DisplaySettingValueObject } from 'src/types/lesson'
import _ from 'lodash'
import { UserSettingInterface, UserSettingValue } from 'src/types'

// @ts-ignore
const getters: GetterTree<SessionStoreInterface, StoreInterface> = {

  getMyStreamingRole: ({ session }, getters, { user }): RoleName => {
    if (!session) return null
    const myUser = user.user
    const myUserInSession = session.itemUsers.find(itemUser => itemUser.user.id === myUser.id)
    if (!myUserInSession) return null
    return myUserInSession?.role?.name
  },

  getUserSettingValue: (state, { getUserSettings }) => ({
    key,
    userId
  }: { key: UserSettingEnum; userId: UserId }): UserSettingValue => {
    const userSettings: object = getUserSettings
    if (Object.prototype.hasOwnProperty.call(userSettings, userId + '')) {
      if (Object.prototype.hasOwnProperty.call(userSettings[userId + ''], key)) return userSettings[userId + ''][key]
      else if (Object.prototype.hasOwnProperty.call(userSettings, '0')) {
        if (Object.prototype.hasOwnProperty.call(userSettings['0'], key)) return userSettings['0'][key]
        else return true
      } else return true
    } else if (Object.prototype.hasOwnProperty.call(userSettings, '0')) {
      if (Object.prototype.hasOwnProperty.call(userSettings['0'], key)) return userSettings['0'][key]
      else return true
    } else return true
  },

  // @ts-ignore
  getUserSettings: ({ sessionSettings }): { [key: number]: UserSettingInterface } => {
    const sessionUserSettings = sessionSettings.filter((itemSetting: ItemSetting) => Object.values(UserSettingEnum).includes(itemSetting.key as UserSettingEnum))

    const userSettings: { [key: number]: UserSettingInterface } = {}

    for (const sessionUserSetting of sessionUserSettings) {
      const userId = sessionUserSetting.user.id
      // @ts-ignore
      _.set(userSettings, [userId, sessionUserSetting.key], sessionUserSetting.value.value)
    }

    // console.log('getters[user/getUserSettings]: userSettings:', JSON.stringify(userSettings, null, 2))

    return userSettings
  },

  getUserIds: ({ session }) => {
    if (!session) return
    const userIds = []
    session.itemUsers.forEach(user => {
      if (user.role.id === RoleIdNameEnum.ATTENDEE) {
        userIds.push(user.user.id)
      }
    })
    return userIds
  },

  getDefaultUserSettings: ({ sessionSettings }): Array<ItemSetting> => {
    return sessionSettings.filter((sessionSetting: ItemSetting) => sessionSetting.user.id === 0)
  },

  getDisplayMode: ({ sessionSettings }: SessionStoreInterface): DisplaySettingValue => {
    // if no setting found return STANDARD view
    if (!sessionSettings) return DisplaySettingValue.STANDARD

    const displayMode = sessionSettings.find(setting => {
      if (setting.key === DisplaySetting.MODE) return setting
    })

    // has settings but no setting found for display mode, return STANDARD view
    if (displayMode) {
      const value: DisplaySettingValueObject = displayMode.value
      return value.display
    } else {
      return DisplaySettingValue.STANDARD
    }
  },

  isConferencingEnabled: ({ sessionSettings }): any => {
    let isConferencingEnabled = false
    sessionSettings.forEach((setting: ItemSetting) => {
      if (setting.key === SessionSettingEnum.CONFERENCING) {
        isConferencingEnabled = JSON.parse(setting.value.value)
      }
    })
    return isConferencingEnabled
  },

  getZoomLink: ({ sessionSettings }): any => {
    let zoomLink = null
    sessionSettings.forEach((setting: ItemSetting) => {
      if (setting.key === SessionSettingEnum.ZOOMLINK) {
        const regexp = new RegExp('https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)')
        if (regexp.test(setting.value.value)) {
          zoomLink = setting.value.value
        }
      }
    })
    return zoomLink
  },

  getActiveMaterial: ({ sessionSettings }): any => {
    let material = null
    sessionSettings.forEach((setting: ItemSetting) => {
      if (setting.key === ContentSetting.MATERIAL) {
        material = JSON.parse(setting.value)
      }
    })
    return material
  },

  isRecognitionInLesson: ({ session }): any => {
    if (!session || !session.items) return false
    let isRecognitionInLesson = false
    session.items.forEach(item => {
      if (item.type === ItemTypeEnum.RECOGNITION || item.type === ItemTypeEnum.SPECIALAWARDING) isRecognitionInLesson = true
    })
    return isRecognitionInLesson
  },

  getActiveScreenStream: (state, { getActiveMaterial }): any => {
    const material = getActiveMaterial
    if (!material) return null
    const acceptedTypes = [AssetTypeEnum.URL, AssetTypeEnum.URL_YOUTUBE]
    if (acceptedTypes.includes(material.type)) {
      return material
    } else return null
  },

  getActiveCameraStream: ({ sessionSettings }): any => {
    let stream = null
    sessionSettings.forEach((setting: ItemSetting) => {
      if (setting.key === ContentSetting.SPOTLIGHT) {
        stream = JSON.parse(setting.value)
      }
    })
    return stream
  },

  getActiveInfo: ({ sessionSettings }): any => {
    let info = null
    sessionSettings.forEach((setting: ItemSetting) => {
      if (setting.key === ContentSetting.INFO) {
        info = JSON.parse(setting.value)
      }
    })
    return info
  },

  getQuestionExpansionStatus: ({ sessionSettings }): any => {
    let status = null
    sessionSettings.forEach((setting: ItemSetting) => {
      if (setting.key === ContentSetting.EXPANSION_STATUS) {
        status = setting.value
      }
    })
    return status
  },

  getItemRecognitions: ({ session }): any => {
    if (!session) return
    return session.itemRecognitions
  }
}

export default getters
